import { useParams, Link } from "react-router-dom";
import medicalFacilities from "../data/medicalFacilities";

function MedicalFacilityDetail() {
    const { id } = useParams();
    const facility = medicalFacilities.find((item) => item.id === id);

    if (!facility) {
        return (
            <div className="text-center py-20">
                <h2 className="text-2xl font-bold">Facility Not Found</h2>
            </div>
        );
    }

    return (
        <section className="py-16 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center bg-white rounded-3xl shadow-2xl p-8 md:p-12">
                    {/* LEFT – TEXT */}
                    <div>
                        <h1 className="text-3xl md:text-4xl font-bold text-[#0b3c78] mb-3">
                            {facility.title}
                        </h1>

                        <p className="italic text-blue-600 mb-5 text-lg">
                            “{facility.motto}”
                        </p>

                        <p className="text-gray-700 leading-relaxed mb-6 text-base md:text-lg">
                            {facility.overview}
                        </p>

                        <h3 className="text-xl font-semibold text-[#0b3c78] mb-3">
                            Services Provided:
                        </h3>

                        <ul className="space-y-2 mb-8">
                            {facility.services.map((service, index) => (
                                <li key={index} className="flex items-start gap-2 text-gray-700">
                                    <span className="text-blue-600 font-bold">✔</span>
                                    {service}
                                </li>
                            ))}
                        </ul>

                        <Link
                            to="/medical-facilities"
                            className="inline-block mt-4 px-6 py-3 rounded-xl bg-blue-700 text-white font-semibold hover:bg-blue-800 transition"
                        >
                            ← Back to Facilities
                        </Link>
                    </div>

                    {/* RIGHT – IMAGE */}
                    <div className="w-full">
                        <img
                            src={facility.image}
                            alt={facility.title}
                            className="w-full h-[260px] sm:h-[320px] md:h-[380px] lg:h-[450px] object-contain rounded-2xl shadow-lg bg-gray-50"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MedicalFacilityDetail;
